<template>
    <div class="bulma">
        <div class="modal"
             :class="{ 'is-active': isShown }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <svg class="modal-card-icon">
                        <use xlink:href="#icon-blog-settings"></use>
                    </svg>
                    <h2 class="modal-card-title">
                        {{ trans.modal_title.was_published }}
                    </h2>
                    <a
                        @click="closeModal"
                        :title="trans.buttons.close"
                    >
                        <svg class="close-modal">
                            <use xlink:href="#icon-cross"></use>
                        </svg>
                    </a>
                </header>
                <section class="modal-card-body">
                    <div v-html="deletingExistingArticleText"></div>
                </section>
                <footer class="modal-card-foot">
                    <button
                        @click="deletePost"
                        :disabled="isRequestInProgress"
                        v-if="!isRequestSuccessfull"
                        class="button is-info"
                    >
                        {{ transButtons.action }}
                    </button>
                    <button
                        @click="closeModal"
                        :disabled="isRequestInProgress"
                        class="button"
                    >
                        {{ transButtons.cancel }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "BaseBlogDeleteExistingPostModal",
    computed: {
        ...mapGetters('baseBlogManager', {
            isShown: 'baseBlogDeleteExistingPostModalIsShown',
        }),
        ...mapGetters('baseBlogManager', [
            'trans',
            'actions',
            'isRequestInProgress',
            'baseBlogHash',
            'baseBlogPostHash',
            'postHashToDelete',
            'isRequestSuccessfull',
            'posts',
            'documentNameToDelete',
            'errorMessage',
        ]),
        ...mapGetters('baseDocumentData', [
            'documentName',
        ]),
        deletingExistingArticleText() {
            if (this.errorMessage) {
                return this.errorMessage;
            }

            if (this.isRequestSuccessfull) {
                return this.trans.blog.publishing.successfull_deletion_message;
            } else {
                let postUrl = this.replaceWildcards(
                    this.actions.show,
                    {
                        base_blog_hash: this.baseBlogHash,
                        post_hash: this.postHashToDelete ?? this.baseBlogPostHash
                    }
                );

                return this.replaceWildcards(
                    this.trans.blog.publishing.delete_existing_post_message,
                    {
                        name: this.documentNameToDelete ?? this.documentName,
                        url: postUrl
                    }
                );
            }

        },
        transButtons() {
            if (!this.isRequestSuccessfull) {
                return {action: this.trans.buttons.delete, cancel: this.trans.buttons.cancel};
            }

            return {cancel: this.trans.buttons.close};
        },
    },
    methods: {
        ...mapActions('baseBlogManager', [
            'deletePost',
            'unsetIsRequestSuccessfull',
            'hideBaseBlogDeleteExistingPostModal',
            'restoreModalWindowState',
            'unsetIsToPublish',
            'setDocumentNameToDelete',
            'unsetDocumentNameToDelete',
            'unsetPostHashToDelete',
            'unsetErrorMessage',
        ]),
        closeModal() {
            this.hideBaseBlogDeleteExistingPostModal();
            this.unsetIsRequestSuccessfull();
            this.restoreModalWindowState();
            this.unsetIsToPublish();
            this.unsetErrorMessage();
        },
    },
    watch: {
        isShown(newValue, oldValue) {
            if (newValue && this.posts.length >= 1) {
                this.setDocumentNameToDelete();
            } else {
                this.unsetDocumentNameToDelete();
                this.unsetPostHashToDelete();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .close-modal {
        width: 16px;
        height: 16px;
        fill: $white;
        &:hover {
            fill: $black;
        }
    }

    .modal-card-body {
        word-break: break-word;
    }
</style>
